import {
  FETCH_EVENTS,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  CREATE_EVENT,
  FETCH_GAMES_FOR_EVENTS,
  FETCH_GAMES_FOR_EVENTS_SUCCESS,
  FETCH_GAMES_FOR_EVENTS_FAILURE,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  CREATE_EVENT_RESET,
  FETCH_SINGLE_EVENT,
  FETCH_SINGLE_EVENT_SUCCESS,
  FETCH_SINGLE_EVENT_FAILURE,
  SINGLE_EVENT_RESET,
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT_RESET,
  FETCH_EVENT_AUDIT_LOGS,
  FETCH_EVENT_AUDIT_LOGS_SUCCESS,
  FETCH_EVENT_AUDIT_LOGS_FAILURE,
  EVENT_AUDIT_LOG_RESET,
  GAMES_FOR_EVENTS_RESET,
  MARK_EVENT_FOR_DELETION,
  MARK_EVENT_FOR_DELETION_SUCCESS,
  MARK_EVENT_FOR_DELETION_FAILURE,
} from '../constants';

export const fetchEvents = ({
  limit, offset, orderBy, sort, markedForDeletion,
}) => ({
  type: FETCH_EVENTS,
  payload: {
    limit,
    offset,
    orderBy,
    sort,
    markedForDeletion,
  },
});

export const fetchEventsSuccess = ({ totalCount, events, offset }) => ({
  type: FETCH_EVENTS_SUCCESS,
  payload: {
    totalCount,
    events,
    offset,
  },
});

export const fetchEventsFailure = () => ({
  type: FETCH_EVENTS_FAILURE,
});

export const createEvent = ({
  name,
  points,
  restrictionsGames,
  restrictionsFirstTime,
  status,
}) => ({
  type: CREATE_EVENT,
  payload: {
    name,
    points,
    restrictionsGames,
    restrictionsFirstTime,
    status,
  },
});

export const createEventSuccess = () => ({
  type: CREATE_EVENT_SUCCESS,
});

export const createEventFailure = ({ errorMessage }) => ({
  type: CREATE_EVENT_FAILURE,
  payload: {
    errorMessage,
  },
});

export const createEventReset = () => ({
  type: CREATE_EVENT_RESET,
});

export const fetchGamesForEvents = () => ({
  type: FETCH_GAMES_FOR_EVENTS,
});

export const fetchGamesForEventsSuccess = ({ games }) => ({
  type: FETCH_GAMES_FOR_EVENTS_SUCCESS,
  payload: {
    games,
  },
});

export const fetchGamesForEventsFailure = () => ({
  type: FETCH_GAMES_FOR_EVENTS_FAILURE,
});

export const resetGamesForEvents = () => ({
  type: GAMES_FOR_EVENTS_RESET,
});

export const fetchSingleEvent = ({ eventId }) => ({
  type: FETCH_SINGLE_EVENT,
  payload: {
    eventId,
  },
});

export const fetchSingleEventSuccess = ({ event }) => ({
  type: FETCH_SINGLE_EVENT_SUCCESS,
  payload: {
    event,
  },
});

export const fetchSingleEventFailure = () => ({
  type: FETCH_SINGLE_EVENT_FAILURE,
  payload: {},
});

export const resetSingleEvent = () => ({
  type: SINGLE_EVENT_RESET,
  payload: {},
});

export const updateEvent = ({ event }) => ({
  type: UPDATE_EVENT,
  payload: {
    event,
  },
});

export const updateEventSuccess = ({ event }) => ({
  type: UPDATE_EVENT_SUCCESS,
  payload: {
    event,
  },
});

export const updateEventFailure = () => ({
  type: UPDATE_EVENT_FAILURE,
  payload: {},
});

export const updateEventReset = () => ({
  type: UPDATE_EVENT_RESET,
  payload: {},
});

export const markEventForDeletion = ({ eventName }) => ({
  type: MARK_EVENT_FOR_DELETION,
  payload: {
    eventName,
  },
});

export const markEventForDeletionSuccess = () => ({
  type: MARK_EVENT_FOR_DELETION_SUCCESS,
  payload: {},
});

export const markEventForDeletionFailure = () => ({
  type: MARK_EVENT_FOR_DELETION_FAILURE,
  payload: {},
});

export const fetchEventAuditLogs = ({
  eventId, limit, offset, orderBy,
}) => ({
  type: FETCH_EVENT_AUDIT_LOGS,
  payload: {
    eventId,
    limit,
    offset,
    orderBy,
  },
});

export const fetchEventAuditLogsSuccess = ({ auditLogs, totalCount, offset }) => ({
  type: FETCH_EVENT_AUDIT_LOGS_SUCCESS,
  payload: {
    auditLogs,
    totalCount,
    offset,
  },
});

export const fetchEventAuditLogsFailure = () => ({
  type: FETCH_EVENT_AUDIT_LOGS_FAILURE,
  payload: {},
});

export const resetEventAuditLogs = () => ({
  type: EVENT_AUDIT_LOG_RESET,
  payload: {},
});



// WEBPACK FOOTER //
// ./src/js/redux/actions/eventsActions.js